module.exports = __webpack_public_path__ + "static/media/dndAnimation.1ae12d84.gif";